//
// Create the domain URLs dynamically based on the current window.location.hostname. This allows us to avoid
// CORS issues if we are calling the API from *.online or *.com because we have DNS entries for both that
// point to the same place.
//
const lastDotPosition = window.location.hostname.lastIndexOf('.');
const tld = window.location.hostname.substring(lastDotPosition + 1);
export const environment = {
  production: true,
  apiBaseUrl: `https://api.fs.ralacademy.${tld}`,
  logoutRedirectUrl: `https://members.ralacademy.${tld}/`,
  serverPort: 8080,
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts